import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function MarriageStep(): ReactElement {
  const dispatch = useDispatch();
  const { married: married } = useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('are_you_married');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <CardPadding>
      <CardHeader header="Are you married?" />
      <Formik
        initialValues={{ married }}
        onSubmit={onSubmit}
        validationSchema={createYesNoObjectSchema('married')}
      >
        <Form ref={formRef}>
          <YesOrNoStepCreator name="married" />
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { MarriageStep };
